import { Goals } from "@/clients/models/Goals";
import { GoalsService } from "@/clients/services/GoalsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useUpdateGoals = () => {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, isError, error } = useMutation({
    mutationFn: async (data: Goals) => {
      const user = guardGetUserFromLocalStorage();
      await GoalsService.updateGoalsApiV1GoalsPut(user.id, data);
    },
    onSuccess: () => {
      // Goal changes recompute calories & macros on the backend.
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.NUTRITIONAL_REQUIREMENT],
      });
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.CALORIE_BUDGET],
      });
    },
  });

  return {
    updateGoals: mutate,
    updateGoalsAsync: mutateAsync,
    isUpdating: isPending,
    isError,
    error,
  };
};
